"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SET_PARENTAL_PIN_QUERY = "\n    mutation SetParentalPin($pin: String!) {\n      setParentalPin(pin: $pin)\n    }\n";
exports.default = SET_PARENTAL_PIN_QUERY;
//# sourceMappingURL=setParentalPin.js.map